import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

const prefixUrL = 'surveystudentanalysis/'

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columnsArray = [
    { type: 'selection' },
    {
        key: '$index',
        label: '序号',
        width: 50
    },
    {
        key: 'orgName2',
        label: '二级学院(学校)',
        width: 80
    },
    {
        key: 'orgName',
        label: '部门（专业）名称',
        width: 80
    },
    {
        key: 'targetName',
        label: '指标名称',
        width: 80
    },
    // {
    //     key: 'time',
    //     label: '次数',
    //     width: 30
    // },
    {
        key: 'score',
        label: '平均分数',
        width: 50
    },
    {
        key: 'midScore',
        label: '中位数',
        width: 50
    }
]

const headers = utils.columns([
    { type: 'selection' },
    {
        key: '$index',
        label: '序号',
        width: 50
    },
    {
        key: 'orgName2',
        label: '二级学院(学校)',
        width: 80
    },
    {
        key: 'orgName',
        label: '部门（专业）名称',
        width: 80
    },
    {
        key: 'targetName',
        label: '指标名称',
        width: 80
    },
    // {
    //     key: 'time',
    //     label: '次数',
    //     width: 30
    // },
    {
        key: 'score',
        label: '平均分数',
        width: 50
    },
    {
        key: 'midScore',
        label: '中位数',
        width: 50
    }
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`${prefixUrL}orgOrTarget/analysis3?` + params.join('&'), keywords)
        .then(response => {
            let extParams = response.payload.meta.extParams;
            let newArray = []
            if (extParams) {
                for (let i = 0; i < columnsArray.length; i++) {
                    newArray.push(columnsArray[i])
                    if (i === 3) {
                        extParams.options.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value,
                                width: 150
                            })
                            newArray.push({
                                key: `${o.name}Time`,
                                label: '评价次数',
                                width: 100
                            })
                        })
                    }
                }
            }
            return {
                data: response.payload.data,
                meta: response.payload.meta,
                headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
            };
        })
        .then(response => (Object.assign({
            headers: response.headers,
            result: (response.data.dataList || []).map(item => {
                return Object.assign(item, {
                    backFlag: response.backFlag
                })
            }),
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            meta: response.meta,
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {

};


export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    getSelection,
    redirect,
}